import card1 from '../images/cardImages/card1.png'
import card2 from '../images/cardImages/card2.webp'
import card3 from '../images/cardImages/card3.webp'
import card4 from '../images/cardImages/card4.webp'
import card5 from '../images/cardImages/card5.webp'
import card6 from '../images/cardImages/card6.png'

const cardData = [
    {
        imgSrc: card1,
        title: 'Local User Account Windows 11',
        para: 'Learn about how to create an account ',
        postLink:'https://www.makeretech.com'
    },
    {
        imgSrc: card2,
        title: 'Disable Show More Option Windows 11',
        para: 'Learn about how to disable the options',
        postLink:'https://www.makeretech.com'
    },
    {
        imgSrc: card3,
        title: 'Install Google Play Store Windows 11',
        para: 'Learn about how to install the play store',
        postLink: 'https://www.makeretech.com'
    },
    {
        imgSrc: card4,
        title: 'Set and Edit Alarm Windows 11',
        para: 'Learn about how to setup the alarm',
        postLink:'https://www.makeretech.com'
    },
    {
        imgSrc: card5,
        title: 'Setup and Use iCloud Windows 11',
        para: 'Learn about how to use apple icloud',
        postLink:'https://www.makeretech.com'
    },
    {
        imgSrc: card6,
        title: 'Notepad Dark Mode Windows 11',
        para: 'Learn about how to enable the dark mode',
        postLink:'https://www.makeretech.com'
    },
]

export default cardData;